import * as Utils from "../utils";

export const schema = [
  {
    id: "/Types/Param/Type/Text",
    type: "object",
    properties: {
      ...Utils.properties,
      default: {
        label: "Default value",
        type: "string",
        minLength: 0,
        default: "",
      },
      // `html`, `css`, `javascript` and `json` all render as a plain textarea
      // today. They are kept as distinct values anyway because they are what
      // decides the editor once a code widget exists, and a stored value that
      // has to be re-chosen later is worse than one that is already right.
      type: {
        label: "Type",
        type: "string",
        default: "text",
        enum: [
          "text",
          "textarea",
          "password",
          "html",
          "css",
          "javascript",
          "json",
        ],
      },
      pattern: {
        label: "Pattern",
        type: "string",
        minLength: 0,
        default: "",
      },
      minLength: {
        label: "Minimum length",
        type: "number",
        default: 0,
      },
      maxLength: {
        label: "Maximum length",
        type: "number",
        default: 128,
      },
    },
    required: [],
  },
];
